import repository from "@/plugins/axios/secureClient";

export const OpenFile = async (resource, method = "GET", options = {}) => {
  const response = await repository({
    ...options,
    url: resource,
    method: method,
    responseType: "blob"
  });
  const file = new Blob([response.data], {
    type: response.headers["content-type"]
  });
  const fileURL = URL.createObjectURL(file);
  window.open(fileURL);
};

export const DownloadFile = async (resource, method = "GET", options = {}) => {
  const response = await repository({
    ...options,
    url: resource,
    method: method,
    responseType: "blob" // important
  });
  let filename = response.headers["filename"] || "file";
  const file = new Blob([response.data], {
    type: response.headers["content-type"]
  });
  const fileURL = URL.createObjectURL(file);
  const link = document.createElement("a");
  link.href = fileURL;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
};
